import OrderState from '~/constants/common/OrderState';
import {
  useUserPurchasing,
  useVehicleAvailability
} from '~/context/vdp/UserVehicleContext';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';

export default function useShouldDisplayOrderStatus() {
  const { orderState, vehicle: { vehicleId: purchasingVehicleId = 0 } = {} } =
    useUserPurchasing();
  const { vehicleId: currentVehicleId = 0 } = useGetVehicleDetails();
  const { isLockedByThisUser } = useVehicleAvailability();

  return (
    purchasingVehicleId === currentVehicleId &&
    orderState !== OrderState.Reserved &&
    orderState !== OrderState.RecentlyPurchased &&
    isLockedByThisUser
  );
}
